.SyncResult {
    max-width: 460px;
    margin: 40px auto;
    padding: 40px 28px;
    text-align: center;
}

.SyncResult__mark {
    display: grid;
    place-items: center;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: var(--soniq-t--global--background--color--status--success--default);
    border: 1px solid var(--soniq-t--global--border--color--status--success--default);
    color: var(--soniq-t--global--text--color--status--success--default);
}

.SyncResult__sub {
    max-width: 40ch;
}

.SyncResult__stat {
    padding: 14px 20px;
    text-align: center;
}
